import initializeMenu from "./menu";
import initializePromotionMessage from "./promotionMessage";
import initializeHeaderTabList from "./headerTabList";
import initCurrentCityNotification from "./currentCityNotification";
import initHeaderAccessibility from "./acessibility";
import initializeMinicart from "./minicart";

const initializeHeader = () => {
    initializeMenu();
    initializePromotionMessage();
    initializeHeaderTabList();
    initCurrentCityNotification();
    initHeaderAccessibility();
    initializeMinicart();
};

export default initializeHeader;
